export enum IProgressViewStatus {
  None = "None",
  Completed = "Completed",
  Failed = "Failed"
}